<template>
  <div class="main-content-container container-fluid px-4" style="margin-top:-55px">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Utilities</span>
        <h3 class="page-title">Image search</h3>
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Image search</h6>
        <!-- <span>
            Note : ** The excel format "Add Only two Columns, and the Column headers are Asin,  URL" 
        </span> -->

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="ImageSearch">
                <d-form-row>
                  <!-- Email -->

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload For Image  Search</label>
                    <div class="col-md-7">
                     <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                    <input id="exampleInputEmail1" v-model="ImageSearch.DataModel.Data.SearchInput" autocomplete="off" type="text" placeholder="User Name" class="form-control"/>
                          </a>
                    </div>
                  </d-col>
                                  <d-col md="12" class="form-group row"  v-if="ImageSearch.DataModel.UIData.ExportData.length > 0" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="ImageSearch.DataModel.UIData.ExportData"  name="ImageSearch"><span style="marige-top:10px;" > Download Image Details </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                </d-form-row>
 
                <br />

                <div class style="text-align:center">
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    :disabled="ImageSearch.DataModel.Data.SearchInput==null"
                    @click="GetImageURL"
                    style="margin-right:10px"
                  >Submit</d-button>
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="ClearImageSearch"
                  >Cancel</d-button>
                </div>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="ImageSearch.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
// import VueToast from "vue-toast-notification";
// import "vue-toast-notification/dist/theme-default.css";
// Vue.use(VueToast);
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: "ImageSearch",
  data() {
    return {
      ImageSearch: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: false, // block/none
        DataModel: {
          Data: {
            Token:null,
            SearchInput:null,
            CRUD:null,
            URL: "https://images-na.ssl-images-amazon.com/images/I/81aWppHNqOL._AC_SL1500_.jpg",
            URLList:[]
          },
          UIData: {
              LoadedFileName:null,
              ExportData:[],
          },
        },
        PageState: "Default",
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0,
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0,
          },
        },
        GridInfo: {},
        ValidationInfo: {},
        Masters: {
          ImageSearchList: [],
        },
        Modal: {},
        CharRestrict: {},
      },
    };
  },
  mounted() {
    
  },
  methods: {
    Select() {
      console.log(this.ImageSearch.DataModel.Data);
    },

    SubmitImageSearch() {
      
 
    },

     /**
     * Import table
     */
     importExcel(e) {

        

      const files = e.target.files;
      this.ImageSearch.PageLoad = true;
      this.ImageSearch.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.ImageSearch.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
   

        this.ImageSearch.DataModel.Data.URLList=[];

            var exceldata ={
                Asin:null,
                URL:null

            }
          for (var i = 0; i < ws.length; i++) {


            if(ws[i].Asin !=undefined)
            {
                exceldata.Asin = ws[i].Asin;
            }
            else
            {
                exceldata.Asin = null;
            }

            if(ws[i].URL !=undefined)
            {
                exceldata.URL = ws[i].URL;
            }
            else
            {
                exceldata.URL = null;
            }

                this.ImageSearch.DataModel.Data.URLList.push(Utilities.JsonCopy(exceldata));
          }
 
          this.ImageSearch.PageLoad = false;

        } catch (e) {
          console.log(e); 
            this.ImageSearch.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

    // ClearImageSearch() {
    //   this.ImageSearch.DataModel.Data.SearchInput=null;
    // },


  GetImageURL(){
    // console.log(encodeURIComponent(this.ImageSearch.DataModel.Data.SearchInput));
     window.open("https://www.google.com/searchbyimage?image_url="+encodeURIComponent(this.ImageSearch.DataModel.Data.SearchInput), "_blank");    
  },  

   GetImageData(){
      let vm = this;
      vm.ImageSearch.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ImageSearch.DataModel.Data.Token = Token;
      this.ImageSearch.DataModel.Data.CRUD = "ImageSearch";
      var dataString = JSON.stringify(this.ImageSearch.DataModel.Data);
       vm.ImageSearch.PageLoad = true;
      axios.post("APIScript/PHP/APIService/ImageSearch/ImageSearch.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ImageSearch.PageLoad = false;
            var ExportData = response.data.Result;

            var ResultData = {
                        Asin :null,
                        ImageURL :null,
                        URL :null,
                        Title :null,
                        Description :null,
                        }
                ExportData.map(function(value,key){
                            ResultData = {
                                Asin :null,
                                ImageURL :null,
                                URL :null,
                                Title :null,
                                Description :null,
                            }
                        ResultData.Asin = value.ImageData.Asin;
                        ResultData.ImageURL = value.ImageData.ImageURL;
                        var tempData = Utilities.JsonCopy(value.ImageData.Search);
                        if(tempData.length !=undefined)
                        {
                            if(tempData.length > 0)
                            {
                                tempData.map(function(nvalue,nkey){
                                ResultData.URL = nvalue.url;
                                ResultData.Title = nvalue.title;
                                ResultData.Description = nvalue.description;
                                });
                            }
                            else
                            {
                                ResultData.URL = "<NA>";
                                ResultData.Title = "<NA>";
                                ResultData.Description = "Link Is Not Available";
                            }
                        }
                        else
                        {
                            ResultData.Description = value.ImageData.Search;
                        }
                        vm.ImageSearch.DataModel.UIData.ExportData.push(Utilities.JsonCopy(ResultData));
                });
                vm.ImageSearch.PageLoad = false;
          } else {
                vm.$swal.fire("Oops", "Something went worng", "error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.ImageSearch.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });


// RLdata = [
// {
// description:"Amazon.com: mug.",
// rank:1,
// title:"mug - Amazon.com",
// url:"https://www.amazon.com/mug/s?k=mug",
// }
// ]

      },

    ClearImageSearch() {
        document.getElementById("ImageSearch").reset();
        this.ImageSearch.DataModel.Data.SearchInput=null;
    },
    SelectMobileNumber() {
 
    },
  },
};
</script>
